// extracted by mini-css-extract-plugin
export default {"body":"BottomDrawer_body__i6JW5","separator":"BottomDrawer_separator__3oj1u","titleRow":"BottomDrawer_titleRow__yFUI5"};